import { render, staticRenderFns } from "./PortafolioLiteSites.vue?vue&type=template&id=a3d30a04&scoped=true"
import script from "./PortafolioLiteSites.vue?vue&type=script&lang=js"
export * from "./PortafolioLiteSites.vue?vue&type=script&lang=js"
import style0 from "./PortafolioLiteSites.vue?vue&type=style&index=0&id=a3d30a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d30a04",
  null
  
)

export default component.exports